/* Anonymous, consent-aware add-on usage. Never send text, files or customer IDs. */
(() => {
  'use strict';
  if (window.stAddonUsage) return;
  const endpoint = 'https://merchant-tools-suite.replit.app/api/events/batch';
  const allowed = new Set(['addon_open', 'addon_selected', 'addon_removed', 'engraving_preview_used', 'addon_added_to_cart']);
  const seen = new WeakMap();
  let session;
  function permitted() {
    return navigator.doNotTrack !== '1' && navigator.globalPrivacyControl !== true &&
      window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }
  function track(root, name, details = {}, once = false) {
    try {
      if (!root || !allowed.has(name) || !permitted()) return;
      // Only coarse package metadata: never text, fonts, files or artwork.
      const option = window.stEngravingPackages?.selected(root)?.option;
      if (name === 'engraving_preview_used' && !option) return;
      const profile = window.stEngravingLocations?.profile(root);
      const metadata = {
        source: 'shopify-addons',
        addon: details.addon === 'pins' ? 'pins' : 'engraving',
        product: location.pathname.match(/\/products\/([^/]+)/)?.[1]?.slice(0, 180) || '',
        model: profile?.size || '',
        kind: ['text', 'logo'].includes(option?.dataset.kind) ? option.dataset.kind : '',
        wheel_sides: profile?.wheelSides || 0,
        frame_sides: profile?.frameSides || 0,
        package: /^[A-Z-]{4,12}$/.test(profile?.package || '') ? profile.package : '',
        quantity: Math.min(999, Math.max(1, Number(details.quantity) || 1))
      };
      if (metadata.addon === 'pins') {
        metadata.kind = '';
        metadata.wheel_sides = metadata.frame_sides = 0;
        metadata.package = '';
      }
      const key = [name, metadata.addon, metadata.model, metadata.kind, metadata.wheel_sides, metadata.frame_sides, metadata.package].join(':');
      let marks = seen.get(root);
      if (!marks) { marks = new Set(); seen.set(root, marks); }
      if (once && marks.has(key)) return;
      marks.add(key);
      if (!session) {
        try {
          session = sessionStorage.getItem('st-addon-session');
          if (!session) { session = 'shop-' + crypto.randomUUID(); sessionStorage.setItem('st-addon-session', session); }
        } catch { session = 'shop-' + crypto.randomUUID(); }
      }
      // keepalive preserves confirmed add events during the cart redirect.
      fetch(endpoint, {
        method: 'POST', credentials: 'omit', keepalive: true,
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({session_id: session, events: [{type: 'action', name, metadata, occurred_at: new Date().toISOString()}]})
      }).catch(() => {}); // Analytics cannot block shopping.
    } catch { /* Consent or storage may be unavailable; do not collect. */ }
  }
  window.stAddonUsage = {track};
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {});
  }
})();